import { ReactNode } from 'react'

interface IPageWrapper {
  children: ReactNode
  className?: string
}

const PageWrapper = ({ children, className }: IPageWrapper) => (
  <main className={`page-content ${className} pagePadding`}>{children}</main>
)
export default PageWrapper
